<div class="container-fluid" style="overflow: hidden;">
    <div class="row" style="height:100vh">
      <div class="col-12 col-md-1 p-0 md-height side-menu-wrapper" >
        <app-side-menu></app-side-menu>
      </div>
      <div class="col-12 col-md p-0" style="background:#F0FAFF; 
      width: calc(100vw - 200px); padding:24px 24px 0px 24px !important;"
      [ngClass]="{'height-overflow':fromDashboard}">
        <app-top-bar></app-top-bar>
        <router-outlet style="height: 100%; width: 100%;"></router-outlet>
      </div>
    </div>
</div>